import Actions from 'actions';

const initialState = Object.freeze({});

function create(state = initialState, action) {
  switch (action.type) {
    case Actions.CREATE_USER_REQUEST:
      return initialState;
    case Actions.CREATE_USER_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.CREATE_USER_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default create;
